<!-- 竖向item列表 -->
<template>
	<div class="columnItemList">
		<template v-for="(item) in columnList" >
			<column-item-block :item="item" :key="item.id"></column-item-block>
		</template>
	</div>
</template>
<script>
	import ColumnItemBlock from './ColumnItemBlock.vue'
	export default{
		components:{
			ColumnItemBlock
		},
		props:{
			columnList:Array
		},
		data(){
			return{

			}
		}
	}
</script>
<style lang="scss">
	.columnItemList{
		@include flex(row);
		flex-wrap: wrap;
		justify-content:space-between;
	}
</style>


// WEBPACK FOOTER //
// src/components/ColumnItemList.vue